import moment from "moment";

export const FLASHCARD_SWIPE_THRESHOLD = 96;
// Pixels per second.
export const FLASHCARD_SWIPE_VELOCITY = 800;

export function getFlashcardSwipeResult({ translationX, velocityX }) {
  if(translationX > FLASHCARD_SWIPE_THRESHOLD || velocityX > FLASHCARD_SWIPE_VELOCITY) {
    return "got_it";
  }
  if(translationX < -FLASHCARD_SWIPE_THRESHOLD || velocityX < -FLASHCARD_SWIPE_VELOCITY) {
    return "missed";
  }
  return null;
}

export function getFlashcardLevelPoints({ correct, currentLevel, isFavorites, nextReview }) {
  if(isFavorites) {
    return { level: currentLevel, points: correct ? 2 : 0 };
  }
  if(!correct) {
    return { level: 0, points: 0 };
  }
  const level = Math.min(currentLevel + 1, 4);
  const isBeforeReview = !!nextReview && nextReview > moment().format("YYYY-MM-DD");
  return { level, points: level * 4 * (isBeforeReview ? 0.5 : 1) };
}

export function flipAnswerResult(state, { correct, currentLevel, level, points, previousLevel, previousPoints }) {
  const lostMastered = previousLevel === 4 && currentLevel < 4 ? 1 : 0;
  const gainedMastered = level === 4 && currentLevel < 4 ? 1 : 0;
  const change = correct ? 1 : -1;

  return {
    ...state,
    correctlyAnsweredSentenceCount: state.correctlyAnsweredSentenceCount + change,
    numCorrect: state.numCorrect + change,
    numIncorrect: state.numIncorrect - change,
    numMastered: state.numMastered - lostMastered + gainedMastered,
    points,
    score: state.score - previousPoints + points,
  };
}

export function getLastFlashcardGrade({ flashcardGradeHistory }) {
  return flashcardGradeHistory[flashcardGradeHistory.length - 1];
}

// Grades of the cards gone back over, nearest last; each card comes back graded unless it is regraded.
export function getLaterFlashcardGrade({ flashcardLaterGrades }, index) {
  const laterGrade = flashcardLaterGrades[flashcardLaterGrades.length - 1];
  return laterGrade && laterGrade.index === index ? laterGrade : null;
}

export function canUndoFlashcardGrade(state, index) {
  const lastGrade = getLastFlashcardGrade(state);
  return !!lastGrade && index === lastGrade.index + 1 && !state.flashcardRevealed;
}

export function removeDuplicateAfterIndex(sentences, index, id) {
  for(let i = sentences.length - 1; i > index; i--) {
    if(sentences[i].id === id) {
      return sentences.filter((s, j) => j !== i);
    }
  }
  return null;
}

export const SWIPES_BEFORE_HIDING_GRADE_CORNERS = 5;
const SWIPE_COUNT_KEY = "flashcardSwipeCount";

export function getFlashcardSwipeCount() {
  try {
    return Number(window.localStorage.getItem(SWIPE_COUNT_KEY)) || 0;
  } catch(e) {
    return 0;
  }
}

export function saveFlashcardSwipeCount(count) {
  try {
    window.localStorage.setItem(SWIPE_COUNT_KEY, String(count));
  } catch(e) {
    // do nothing
  }
}
